
import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

@Component({
    inheritAttrs: false,
    name: 'Permissions',
})
export default class Permissions extends Mixins<MixinInterface>() {
    @Prop({ default: null }) role!: any
    @Prop({ default: null }) projectUser!: any

    @Prop({ default: true, type: Boolean }) showHeaderTitle!: boolean

    get permissions() {
        const permissions = [] as Array<string>
        if (this.projectUser) {
            this.projectUser.roles.data.forEach((role) => {
                role.permissions.data.forEach((permission) => permissions.push(permission.id))
                role.includedPermissions.data.forEach((permission) =>
                    permissions.push(permission.id)
                )
            })
        } else if (this.role) {
            this.role.permissions.data.forEach((permission) => permissions.push(permission.id))
            this.role.includedPermissions.data.forEach((permission) =>
                permissions.push(permission.id)
            )
        }

        return [...new Set(permissions)]
    }

    get permissionGroups() {
        return [...new Set(this.permissions.map((item) => item.split('.')[0]))].sort()
    }

    get grouppedPermissions() {
        return this.permissionGroups.map((group) =>
            this.permissions.filter((item) => item.includes(`${group}.`))
        )
    }

    permissionPanel: Array<number> = []

    togglePermissionGroups() {
        if (this.permissionPanel.length === 0) {
            this.permissionPanel = this.permissionGroups.map((_, i) => i)
        } else {
            this.permissionPanel = []
        }
    }
}
